import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chukou",
  "use": "icon-chukou-usage",
  "viewBox": "0 0 1603 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1603 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chukou\"><path d=\"M692.30592 890.13248H183.20384V141.952h509.10208v72.44288l88.8064 62.87872V60.37504H100.6848v908.4928h680.42752v-216.88832l-88.8064 62.86848v75.28448z\" /><path d=\"M798.40768 566.5024h187.41248V462.76096h-187.41248V325.22752l-200.71936 189.40416 200.71936 189.37856v-137.50784z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol